import { ref } from 'vue';
import { EcommerceCreateProductReviewPayload } from '@zyro-inc/site-modules/types';
import StoreApi from '@zyro-inc/site-modules/api/StoreApi';

export const useProductReview = () => {
	const isCreating = ref(false);
	const isCreated = ref(false);
	const isError = ref(false);

	const createProductReview = async ({
		storeId,
		productId,
		rating,
		email,
		reviewerName,
		comment,
	}: EcommerceCreateProductReviewPayload) => {
		isCreated.value = false;
		isError.value = false;
		isCreating.value = true;

		try {
			await StoreApi.createProductReview({
				storeId,
				productId,
				rating,
				email,
				reviewerName,
				comment,
			});

			isCreated.value = true;
		} catch (error) {
			isError.value = true;
			console.error(error);
		} finally {
			isCreating.value = false;
		}
	};

	return {
		createProductReview,
		isCreating,
		isCreated,
		isError,
	};
};
